export default {
  type: 'article',
  aliases: ['article'],
  path: 'Article/ArticleTemplate.vue',
  slices: [{
    name: 'article_paragraph',
    path: 'Article/ArticleParagraph.vue'
  }, {
    name: 'products_carousel_eb',
    path: 'Article/ArticleCarousel.vue'
  }, {
    name: 'article_quote',
    path: 'Article/ArticleQuote.vue'
  }, {
    name: 'article_image',
    path: 'Article/ArticleImage.vue'
  }, {
    name: 'article_chips',
    path: 'Global/GlobalChips.vue'
  }, {
    name: 'article_products',
    path: 'Article/ArticleProducts.vue',
    additional: {
      query: 'products',
      handler(arg) {
        return {
          references: arg.items.map(e => e.reference)
        };
      }
    }
  }, {
    name: 'article_dispatch',
    path: 'Article/ArticleDispatch.vue'
  }, {
    name: 'article_recommendation',
    path: 'Article/ArticleRecommendation.vue'
  }, {
    name: 'tag_list_block',
    path: 'Global/TagListBlock.vue',
    additional: {
      query: 'categories',
      handler(arg) {
        return {
          hashes: arg.items.map(e => e.hash)
        };
      }
    }
  }, {
    name: 'custom_button',
    path: 'Custom/CustomButton.vue'
  }, {
    name: 'landing_video_text',
    path: 'Landing/LandingVideoText.vue'
  }, {
    name: 'secondary_theme',
    path: 'Generic/RelatedCategories.vue'
  }, {
    name: 'offer_footer',
    path: 'Global/GlobalDispatchFooter.vue'
  }]
};